module.exports = __webpack_public_path__ + "img/hierarchy-center.70bc96cb.svg";